var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-overflow"},[(_vm.image)?_c('div',[_c('img',{staticClass:"car-image-overflow",attrs:{"src":_vm.image,"alt":"card"}})]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }